import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  TextField,
} from "@material-ui/core"
import LoadingButton from "../../../LoadingButton"
import useStyles from "./styles"
import { toggleFlaggingDialog } from "../../../../actions/billingDialogs"

const FlaggingDialog = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const [flagNote, setFlagNote] = useState("")

  const open = useSelector(state => state.billingDialogs.flaggingDialogOpen)
  const data = useSelector(state => state.billingDialogs.data)

  const flagFunc = data && data.flagFunc
  const nextStatus = (data && data.nextStatus) || {}
  const funcParams = (data && data.funcParams) || []
  const comment = (data && data.comment) || ""

  // check for either crew flag status id or client flag status id (only 1 will come from table)
  // then checks intended val (setting to any number !4 is unflag) to determine if item slated for resolution
  const itemAlreadyFlagged = nextStatus.crew_flag_status_id
    ? nextStatus.crew_flag_status_id !== 4
    : nextStatus.client_flag_status_id !== 4

  // sets flag note val to comment already existing on item as passed into dialog
  useEffect(
    () => {
      if (comment) {
        setFlagNote(comment)
      }
    },
    [comment]
  )

  const handleClose = () => {
    setTimeout(() => {
      setFlagNote("")
    }, 150)
    dispatch(toggleFlaggingDialog(false))
  }

  // adds in comment to next status object, if resovling a flag clears to empty str
  const handleFlag = () => {
    if (flagFunc) {
      let flagData = {
        ...nextStatus,
        comment: !itemAlreadyFlagged ? flagNote : "",
      }
      flagFunc(flagData, ...funcParams)
    }
    handleClose()
  }

  return (
    <Dialog
      open={open}
      PaperProps={{
        classes: {
          root: classes.dialogPaper,
        },
      }}
    >
      <Box style={{ backgroundColor: "#F04031" }}>
        <DialogTitle disableTypography>
          <Typography variant="h3" style={{ color: "#fff" }}>
            {itemAlreadyFlagged
              ? "Flagged Item"
              : "Report an Issue on this Item:"}
          </Typography>
        </DialogTitle>
      </Box>
      <DialogContent>
        <TextField
          style={{ marginTop: "15px" }}
          disabled={itemAlreadyFlagged}
          id="email-message"
          name="message"
          variant="outlined"
          multiline
          value={flagNote}
          onChange={e => setFlagNote(e.target.value)}
          rows={8}
          rowsMax={12}
          placeholder={!flagNote ? "What is the issue?" : null}
          fullWidth
          InputProps={{
            classes: {
              root: classes.inputRoot,
            },
          }}
        />
      </DialogContent>
      <DialogActions className={classes.buttons}>
        <LoadingButton
          style={{ color: "#9A9A9A" }}
          color="secondary"
          variant="text"
          className={classes.button}
          onClick={handleClose}
        >
          Cancel
        </LoadingButton>
        <LoadingButton
          variant="outlined"
          color={!flagNote.length ? "default" : "secondary"}
          className={classes.button}
          onClick={() => handleFlag()}
          disabled={!flagNote.length}
        >
          {itemAlreadyFlagged ? "Mark As Resolved" : "Save Flag"}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default FlaggingDialog
